export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const HTTP_STATUS = {
  badRequest: 400,
  unauthrized: 401,
  unprocessableEntity: 422
}

export const HTTP_HEADER_SKIP_ERROR = 'Dream-Skip-Error'

export const AUTH_COOKIE = {
  name: 'beu_auth',
  expires: 365,
  path: '/'
}

export const LOCALE_COOKIE = {
  name: 'locale',
  expires: 365,
  path: '/'
}

export const TOKEN_COOKIE = {
  name: '_beu_a_t_',
  path: '/'
}

export const LOGIN_CHECK_COOKIE = {
  name: '_beu_journey_login',
  path: '/'
}

export const BEU_LOGIN_CHECK_COOKIE = {
  name: '_beu_heatmap_login',
  path: '/'
}

export const BEU_LOGIN_FIRST_COOKIE = {
  name: '_beu_heatmap_first_login',
  path: '/'
}

export const BEU_HOST_USER_COOKIE = {
  name: '_beu_host_user_open',
  path: '/'
}

if (IS_PRODUCTION) {
  AUTH_COOKIE.domain = '.beusable.net'
  LOCALE_COOKIE.domain = '.beusable.net'
  TOKEN_COOKIE.domain = '.beusable.net'
  LOGIN_CHECK_COOKIE.domain = '.beusable.net'
  BEU_LOGIN_FIRST_COOKIE.domain = '.beusable.net'
  BEU_LOGIN_CHECK_COOKIE.domain = '.beusable.net'
  BEU_HOST_USER_COOKIE.domain = '.beusable.net'
}

export const CDN_HOST = 'https://dream-cdn.beusable.net'
export const DOCUMENT_TITLE_PREFIX = 'Beusable'

export const UNTAGGED_TAG_ID = -1
export const NOTAG_TAG_ID = -2

export const NEW_CODE_DEPLOY_DATE =
  process.env.VUE_APP_NEW_CODE_DEPLOY_DATE || '2022-08-04'
export const NEW_CODE_INFO_LINK =
  process.env.VUE_APP_NEW_CODE_INFO_LINK || 'https://www.beuillage.net/post/871'

export const SURVEY_MAX_TEXT_ANSWER_COUNT = 100

export const SIGNIN_LINK = process.env.VUE_APP_SIGNIN_LINK || 'https://staging-new-home.beusable.net/signin'
export const REPORT_LINK = process.env.VUE_APP_REPORT_LINK || 'https://staging-solomon.beusable.net/report'
export const SOLOMON_REPORT = process.env.VUE_APP_SOLOMON_REPORT_URL || 'https://staging-solomon.beusable.net'

export const SURVEY_CONSTANT = {
  STATUS_RUNNING: 'run',
  STATUS_WAITING: 'waiting',
  STATUS_STOP: 'stop',
  STATUS_END: 'end',
  STATUS_PREVIEW: 'preview',
  POPUP_STYLE_POPUP_ALWAYS: 'popup',
  POPUP_STYLE_MODAL_ONETIME: 'modal',
  POPUP_LOC_RIGHT: 'right',
  POPUP_LOC_LEFT: 'left',
  TARGET_SCOPE_ALL: 'all',
  TARGET_SCOPE_INCLUDE: 'include',
  TARGET_SCOPE_EXCLUDE: 'exclude',
  TARGET_INCLUDE_SCOPE_ALL: 'all',
  DEVICE_ALL: 'all',
  LANG_KO: 'ko',
  LANG_EN: 'en',
  LANG_JA: 'ja',
  LOAD_AFTER_ONLOAD: 'after load',
  LOAD_AFTER_SCROLL: 'scroll to half',
  LOAD_AFTER_5MIN: 'after 5min',
  LOAD_AFTER_CONVERT: 'after convert',
  ITEM_TYPE_RADIO: 'radio',
  ITEM_TYPE_CHECKBOX: 'checkbox',
  ITEM_TYPE_TEXT: 'text',
  ITEM_TYPE_RANGE: 'range',
  LANG_TYPE_BOWSER: 'bowser', // fave
  LANG_TYPE_FIX: 'fix' // fave
}

export const JAM_PAYMENT_LIST_STATE = {
  JAM_REFUND: 'JAM_REFUND',
  JAM_CHARGE: 'JAM_CHARGE',
  JAM_EXPIRED: 'JAM_EXPIRED',
  MOVE_TO_BASKET: 'MOVE_TO_BASKET',
  MOVE_TO_MY_JAM: 'MOVE_TO_MY_JAM',
  PV_CHARGE: 'PV_CHARGE',
  BUY_REPORT_PREFIX: 'BUY_REPORT_PREFIX',
  BUY_REPORT_INDEPTH: 'BUY_REPORT_INDEPTH',
  BUY_REPORT_PERIOD: 'BUY_REPORT_PERIOD',
  BUY_REPORT_SEGMENT: 'BUY_REPORT_SEGMENT',
  BUY_REPORT_SCROLL: 'BUY_REPORT_SCROLL',
  PAYMENT_4GRIT: '4grit',
  PAYMENT_WIRE: 'WIRE',
  PAYMENT_CARD: 'CARD',
  PAYMENT_NONE: 'PAYMENT_NONE',
  CX_HEATMAP: 'CX_HEATMAP',
  CANCEL_REPORT_PREFIX: 'CANCEL_REPORT_PREFIX',
  CANCEL_REPORT_INDEPTH: 'CANCEL_REPORT_INDEPTH',
  CANCEL_REPORT_PERIOD: 'CANCEL_REPORT_PERIOD',
  CANCEL_REPORT_SEGMENT: 'CANCEL_REPORT_SEGMENT',
  BUY_REPORT_DASHBOARD: 'BUY_REPORT_DASHBOARD',
  BUY_REPORT_DASHBOARD_HELL: 'BUY_REPORT_DASHBOARD_HELL',
  CANCEL_REPORT_DASHBOARD: 'CANCEL_REPORT_DASHBOARD',
  REWARD: 'REWARD'
}

export const JAM_LIST_STATE = {
  JAM_CHARGE: {
    value: 'JAM_CHARGE',
    type: 'add'
  },
  REWARD: {
    value: 'REWARD',
    type: 'add'
  },
  MOVE_TO_BASKET: {
    value: 'MOVE_TO_BASKET',
    type: 'subtract'
  },
  MOVE_TO_MY_JAM: {
    value: 'MOVE_TO_MY_JAM',
    type: 'add'
  },
  PV_CHARGE: {
    value: 'PV_CHARGE',
    type: 'subtract'
  },
  BUY_REPORT: {
    value: ['BUY_REPORT_PREFIX', 'BUY_REPORT_INDEPTH', 'BUY_REPORT_PERIOD', 'BUY_REPORT_SEGMENT', 'BUY_REPORT_SCROLL', 'BUY_REPORT_DASHBOARD', 'BUY_REPORT_DASHBOARD_HELL'],
    type: 'subtract'
  },
  CANCEL_REPORT: {
    value: ['CANCEL_REPORT_PREFIX', 'CANCEL_REPORT_SEGMENT', 'CANCEL_REPORT_PERIOD', 'CANCEL_REPORT_INDEPTH'],
    type: 'add'
  },
  JAM_EXPIRED: {
    value: 'JAM_EXPIRED',
    type: 'subtract'
  }
}

export const PAYMENT_LIST_STATE = {
  PAYMENT_CARD: 'CARD',
  PAYMENT_WIRE: 'WIRE',
  PAYMENT_4GRIT: '4grit',
  PAYMENT_NONE: 'PAYMENT_NONE'
}

export const JAM_BASKET_LIST_STATE = {
  MOVE_TO_BASKET: { value: 'MOVE_TO_BASKET', type: 'add' },
  MOVE_TO_MY_JAM: { value: 'MOVE_TO_MY_JAM', type: 'subtract' },
  CX_HEATMAP: { value: 'CX_HEATMAP', type: 'subtract' },
  JAM_EXPIRED: { value: 'JAM_EXPIRED', type: 'subtract' }
}

export const DEFAULT_TIMEZONE = '+09:00'
export const DEFAULT_TIMEZONE_NAME = 'Asia/Seoul'

export const REFER_PATTERN_DATE = process.env.VU_APP_REFER_PATTERN_DATE || '2023-05-01'

export const SHINHAN_RESAMPLE_START_DATE = process.env.VUE_APP_SHINHAN_RESAMPLE_START_DATE || '2023-05-01'
export const SHINHAN_SAMPLE_END_DATE = process.env.VUE_APP_SHINHAN_SAMPLE_END_DATE || '2023-04-30'
export const K_CAR_SAMPLING_START_DATE = '2025-06-24'
export const SAMSUNG_SAMPLING_START_DATE = '2025-07-01'

export const PAYMENT_FILTER_DEFAULT_START_DATE = '2016-08-03'

export const HEATMAP_STATE = {
  NONE: 'none',
  RUN: 'run',
  STOP: 'stop',
  ERROR: 'error',
  ANALYZING: 'analyzing',
  STOPBYDOMAINCREDITEMPTY: 'stopByDomainCreditEmpty',
  STOPBYUSERCREDITEMPTY: 'stopByUserCreditEmpty',
  STOPBYJAMPVEMPTY: 'stopByJamPvEmpty',
  ENDBYANALYSISDATE: 'endByAnalysisDate',
  SCHEDULEDRUN: 'scheduledRun'
}

export const DATE_FORAMT = 'YYYY-MM-DD'

export const BIG_SESSION_DEFAULT_RANGE_TARGET = [
  '8332dbadf0' // lg.com
]

export const AI_CATEGORY_SECONDARY = [
  'main',
  'list',
  'detail',
  'signin',
  'loginpage',
  'mypage',
  'support',
  'cart',
  'payment',
  'order',
  'event',
  'pricing',
  'purchase',
  'recruit'
]
export const AI_CATEGORY_TERTIARY = [
  'main',
  'list',
  'detail',
  'cta',
  'form',
  'info',
  'etc'
]

export const AI_CATEGORY_NAME = {
  ecommerce: {
    ko: '이커머스&리테일테크',
    en: 'Ecommerce',
    ja: 'ECサイト'
  },
  finance: {
    ko: '핀테크&디지털금융',
    en: 'Finance',
    ja: '金融・ファイナンス'
  },
  entertainment: {
    ko: '미디어&엔터테인먼트테크',
    en: 'Entertainment',
    ja: 'エンタメ・メディア'
  },
  mobility: {
    ko: '온디맨드&모빌리티',
    en: 'Mobility',
    ja: '動画配信&モビリティサービス'
  },
  health: {
    ko: '디지털헬스케어',
    en: 'Health',
    ja: 'デジタルヘルスケア'
  },
  education: {
    ko: '에듀테크',
    en: 'Education',
    ja: 'Eラーニング'
  },
  agency: {
    ko: '디지털에이전시&laas',
    en: 'Agency',
    ja: '広告・マーケティング代理店'
  },
  government: {
    ko: '공공복지&행정서비스',
    en: 'Government',
    ja: '行政サービス'
  }
}

export const AI_CATEGORY = ['ecommerce', 'finance', 'entertainment', 'mobility', 'health', 'education', 'agency', 'government']

export const LOCALE_LIST = [
  {
    code: 'ko',
    title: 'Korean'
  },
  {
    code: 'en',
    title: 'English'
  },
  {
    code: 'ja',
    title: 'Japanese'
  }
]

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]

export const DEVICE_LIST = [
  {
    text: 'Desktop',
    value: 'desktop'
  },
  {
    text: 'Tablet',
    value: 'tablet'
  },
  {
    text: 'Phone',
    value: 'phone'
  }
]

export const CUSTOM_DEFAULT_ID = '_beu_custom_id'

export const DOMAIN_CATEGORY_ICON = {
  'Public Services': 'icon-category-public',
  'Education': 'icon-category-education',
  'Finance': 'icon-category-finance',
  'Technology': 'icon-category-technology',
  'Leisure': 'icon-category-leisure',
  'Consumption/Lifestyle': 'icon-category-retail',
  'Entertainment': 'icon-category-entertainment',
  'Healthcare': 'icon-category-health',
  'Information': 'icon-category-information',
  'IT': 'icon-category-it'
}

export const PLAN_NAME = [
  'Everyone', 'Starter', 'Basic', 'Standard', 'Premium', 'Pro', 'Enterprise'
]
